export default __webpack_public_path__ + "static/media/teddyBear.225ef075.jpg";